export const formatHours = (decimalHours) => {
  const isNegative = decimalHours < 0;
  const absHours = Math.abs(decimalHours);
  const hours = Math.floor(absHours);
  const minutes = Math.round((absHours - hours) * 60);
  const sign = isNegative ? '-' : '';
  return `${sign}${hours}:${minutes.toString().padStart(2, '0')}h`;
};

// Transform server timelog groups to calendar events
// Server sends: [{ label, timelogs: [normalizedRecord, ...] }]
export function transformTimelogsToEvents(groups) {
  if (!Array.isArray(groups)) return [];
  return groups.flatMap(group =>
    (group.timelogs || []).map(log => ({
      title: log.title || log.notes || '',
      start: new Date(log.start),
      end: new Date(log.end),
      date: log.date,
      logId: log.logId,
      projectId: log.projectId || '',
      projectName: log.projectName || '',
      accountId: log.accountId || '',
      accountName: log.accountName || '',
      isWorkTime: log.isWorkTime || false,
      loggedHours: log.loggedHours || 0,
      billable: log.billable || false,
      notes: log.notes || '',
      start_time: log.start_time,
      end_time: log.end_time,
      total_minutes: log.total_minutes,
    }))
  );
}
